import { render } from "./MConnect.vue?vue&type=template&id=67f1bd89&ts=true"
import script from "./MConnect.vue?vue&type=script&lang=ts"
export * from "./MConnect.vue?vue&type=script&lang=ts"

import "./MConnect.vue?vue&type=style&index=0&id=67f1bd89&lang=scss"

import exportComponent from "/home/runner/work/connect-widgets/connect-widgets/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__